/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LiveStreamItem } from './LiveStreamItem';
import {
    LiveStreamItemFromJSON,
    LiveStreamItemFromJSONTyped,
    LiveStreamItemToJSON,
    LiveStreamItemToJSONTyped,
} from './LiveStreamItem';

/**
 * 
 * @export
 * @interface LiveStreamsResponse
 */
export interface LiveStreamsResponse {
    /**
     * 
     * @type {Array<LiveStreamItem>}
     * @memberof LiveStreamsResponse
     */
    streams?: Array<LiveStreamItem>;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamsResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamsResponse
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamsResponse
     */
    offset?: number;
}

/**
 * Check if a given object implements the LiveStreamsResponse interface.
 */
export function instanceOfLiveStreamsResponse(value: object): value is LiveStreamsResponse {
    return true;
}

export function LiveStreamsResponseFromJSON(json: any): LiveStreamsResponse {
    return LiveStreamsResponseFromJSONTyped(json, false);
}

export function LiveStreamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveStreamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'streams': json['streams'] == null ? undefined : ((json['streams'] as Array<any>).map(LiveStreamItemFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
    };
}

export function LiveStreamsResponseToJSON(json: any): LiveStreamsResponse {
    return LiveStreamsResponseToJSONTyped(json, false);
}

export function LiveStreamsResponseToJSONTyped(value?: LiveStreamsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streams': value['streams'] == null ? undefined : ((value['streams'] as Array<any>).map(LiveStreamItemToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

